module.exports = __webpack_public_path__ + "img/word.382798b8.png";